import { createSelector } from '@ngrx/store';
import { Status } from '@essent/common';
import {
  getSupplyAddresses,
  getSupplyAddressesEntries,
  getSupplyAddressesError,
  getSupplyAddressesLoading,
  getSupplyAddressesStatus,
  hasActiveSupplyAddress,
  hasSupplyAddresses,
} from '@supply-address/entity';

import { getSupplyAddressState } from './supply-address.store';

export const getSelectedSupplyAddressState = createSelector(
  getSupplyAddressState,
  (feature) => feature.selectedSupplyAddress
);

export const getSelectedSupplyAddressId = createSelector(
  getSelectedSupplyAddressState,
  (state) => state.selectedSupplyAddressId
);

export const getHasSelectedSupplyAddress = createSelector(
  getSelectedSupplyAddressId,
  (supplyAddressId) => supplyAddressId !== undefined
);

export const getSelectedSupplyAddress = createSelector(
  getSupplyAddressesEntries,
  getSelectedSupplyAddressId,
  (results, id) => results[id || 'unknown']
);

export const getSelectedSupplyAddressIfAvailable = createSelector(
  getSelectedSupplyAddress,
  (selectedSupplyAddress) =>
    selectedSupplyAddress?.supplyAddressId ? selectedSupplyAddress : undefined
);

export const getFirstSupplyAddress = createSelector(
  getSupplyAddresses,
  (supplyAddresses) =>
    supplyAddresses != null ? supplyAddresses[0] : undefined
);

export const getSelectedSupplyAddressExists = createSelector(
  getSelectedSupplyAddressId,
  getSelectedSupplyAddress,
  (selectedId, selectedSupplyAddress) =>
    selectedId != null && selectedSupplyAddress != null
);

export const getSelectedOrFirstSupplyAddress = createSelector(
  getSelectedSupplyAddress,
  getFirstSupplyAddress,
  (selected, first) => selected || first
);

export const hasSupplyAddressesError = createSelector(
  getSupplyAddressesLoading,
  getSupplyAddressesError,
  getSelectedSupplyAddressExists,
  (loading, supplyAddressesError, selectedExists) => {
    return !loading && (!!supplyAddressesError || !selectedExists);
  }
);

export const isSupplyAddressesLoading = createSelector(
  hasSupplyAddressesError,
  getSupplyAddressesStatus,
  (hasError, status) => {
    return !hasError && (status === Status.IDLE || status === Status.PENDING);
  }
);

export const showSupplyAddresses = createSelector(
  hasSupplyAddresses,
  hasSupplyAddressesError,
  (hasSupplyAddressesResult, showError) =>
    hasSupplyAddressesResult && !showError
);

export const getSupplyAddressesAndErrorWithStatuses = createSelector(
  getSupplyAddressesError,
  isSupplyAddressesLoading,
  getSupplyAddressesError,
  getSelectedSupplyAddressExists,
  showSupplyAddresses,
  (
    error,
    showLoading,
    supplyAddressesError,
    supplyAddressExists,
    showSupplyAddressesResult
  ) => {
    return {
      supplyAddressesError,
      showError: !!error,
      supplyAddressExists,
      showLoading,
      showSupplyAddresses: showSupplyAddressesResult,
    };
  }
);

export const shouldSelectSupplyAddress = createSelector(
  hasActiveSupplyAddress,
  getSelectedSupplyAddressId,
  (hasActiveAddresses, selectedSupplyAddress) =>
    hasActiveAddresses && selectedSupplyAddress == null
);
